import { useState, useEffect } from "react";
import { ProviderUser } from "../../types/ProviderUser";
import { FirestoreFamilyRepository } from "../../../infrastructure/repositories/FamilyRepository";
import { Family } from "../../types/Family";

export const useFamilyMembers = (family: Family | null) => {
  const [familyMembers, setFamilyMembers] = useState<
    Record<string, ProviderUser>
  >({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchFamilyMembers = async () => {
      if (family && family.familyId) {
        const familyRepo = new FirestoreFamilyRepository();
        try {
          const membersMap = await familyRepo.getFamilyMembers(family.familyId);
          setFamilyMembers(membersMap);
        } catch (err) {
          setError(err as Error);
          console.error("Error fetching family members:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchFamilyMembers();
  }, [family]);

  return { familyMembers, loading, error };
};
